import { render, staticRenderFns } from "./DisplayReportBenchmarkScores.vue?vue&type=template&id=5917048a"
import script from "./DisplayReportBenchmarkScores.vue?vue&type=script&lang=ts"
export * from "./DisplayReportBenchmarkScores.vue?vue&type=script&lang=ts"
import style0 from "./DisplayReportBenchmarkScores.vue?vue&type=style&index=0&id=5917048a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports